import { compact, flatten } from "lodash-es";

import { django } from "@/api";
import { PromptTemplate, SemanticPaper, SemanticResponse } from "@/types";

interface SemanticParams {
  slug: string;
  prompt: string;
  block?: string;
  keywords?: string;
  fields_of_study?: string;
  start_year?: number;
  end_year?: number;
  offset: number;
  limit: number;
}

const prompt = `Summarize the following text into at most five keywords for a search
query to find related research papers. The search engine will be trying to find
papers that match all keywords, so please create five queries (five keywords
each) trying to constrain each query to one field of research. The queries need
to be separated by newlines. Enumerations or bullet-points are not allowed.

{text}
Keywords:`;

export const getSimilarPapers = async ({
  slug,
}: {
  slug: string;
}): Promise<SemanticPaper[]> => {
  const params: SemanticParams = {
    slug,
    prompt,
    // block
    // keywords // or prompt
    // fields_of_study: "Computer Science,Biology",
    start_year: 1900,
    end_year: 2023,
    offset: 0,
    limit: 5,
  };

  const response = await django.get("llm/semantic/", {
    params,
  });
  console.log("response", response.data);

  return compact(
    flatten(
      (response.data as SemanticResponse[]).map((results) => results.data)
    )
  );
};
